import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Config } from 'ionic-angular';

import { NewsModel } from '../../app/models/news-model';

import { NewsService } from '../../providers/news-service/news-service';

@Injectable()
export class RestNewsService implements NewsService {
  private serverUrl : string;

  constructor(private http: Http, configuration: Config) {
    this.serverUrl = configuration.get('backendUrl');
  }

  public findNewsForEvent(eventCode : string) : Observable<NewsModel[]> {
    return Observable.create(observer => {
	  this.http.get(this.serverUrl+'/api/'+eventCode+'/news/')
        .map(res => this.adaptFromRemoteNews(res.json()))
        .catch(this.handleError)
        .subscribe(data => {
          observer.next(data);
          observer.complete();
        },
        error => {
          this.handleError(error);
          observer.next(error);
        });
    });
  }

  private adaptFromRemoteNews(news: any) : NewsModel[] {
    return null;
    //FIXME: real implementation
    //let eventCode = new EventCodeModel(event.code);
    //return new EventModel(eventCode, event.subEvents.map(s => this.adaptFromRemoteSubEvent(s, eventCode)), event.title, event.description, event.teaser, event.area, event.organizers, event.rsvpDate);
	}

  private handleError(error) {
    console.error(error);
    return Observable.throw((error.status === 404 ? error.text() : error.json().error) || 'Server error while reading news data');
  }

}



// WEBPACK FOOTER //
// ./src/providers/news-service/rest-news-service.ts